import { TelInput } from '../baseInputs'

type Props = {
  label?: string
  name?: string
  helper?: string
  optional?: boolean
}

const Tel = ({ helper, optional, ...rest }: Props) => {
  const name = 'tel'
  const label = 'Phone'

  return (
    <TelInput
      name={name}
      label={label}
      helper={helper}
      optional={optional}
      {...rest}
    />
  )
}

export default Tel
